export const HKID_REGEX = {
	FULL_PART: /^[A-Z]{1,2}[0-9]{6}[0-9A]$/,
	FIRST_PART: /^[A-Z]{1,2}$/,
	ID_PART: /^[0-9]{6}$/,
	CHECK_DIGIT: /^[0-9A]{1}$/
};
export const PASSWORD_VALIDATION_RULES = {
	MIN_LENGTH: 8,
	REGEX:
		'^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!"#$%&\\\'()*+,-./:;<=>?@[\\]^_`{|}~])[A-Za-z\\d!"#$%&\\\'()*+,-./:;<=>?@[\\]^_`{|}~]{8,}$'
};

export const EMAIL_VALIDATION_RULES = {
	REGEX: /^[a-zA-Z0-9.\-_a-z0-9]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
};

export const WEBSITE_REGEX =
	/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;

export const NUMBER_REGEX = /^[0-9]*$/;

export const CHARACTER_REGEX = /^[a-zA-Z ]*$/;

export const LETTER_REGEX = /^[A-Za-z ]*$/;

export const MAXIMUM_LIVED_YEAR_REGEX = /^(?<whole>100|\d{1,2})(?<fract>\.\d{1,8})?$/ // 0 -100

export const NOT_NUMBER_REGEX = /^[^0-9]*$/; //special characters and characters

export const PASSPORT_REGEX = /^(?!^0+$)[a-zA-Z0-9]{6,9}$/;

export const CHINESE_MOBILE_LENGTH = [11];

export const CHINESE_ID_LENGTH = [15, 18];

export const ZIPCODE_REGEX = /^.{1,20}$/;

export const CHINESE_REGEX = /[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]/g